import { addMessages } from '@hana/i18n';

// Chuỗi bảng phải danh sách Job (Mint-Job-1920). Dữ liệu mẫu (thư, việc, thông báo) không dịch.
addMessages('vi', {
  'jobDock.label': 'Bảng bên phải',
  'jobDock.close': 'Đóng bảng',
  'jobDock.an': 'Phân tích',
  'jobDock.task': 'Việc',
  'jobDock.mail': 'Thư',
  'jobDock.noti': 'Thông báo',
  'jobDock.suggest': 'Ask HANA gợi ý',
  'jobDock.suggestLabel': 'Hana gợi ý theo danh sách đang xem',
  'jobDock.sg.rod': '{n} job chưa gửi ROD cho hãng',
  'jobDock.sg.rodSub': 'Chọn sẵn và mở Gửi ROD hàng loạt',
  'jobDock.sg.cut': '{n} job cut-off CY dưới 48h',
  'jobDock.sg.cutSub': 'Chọn sẵn để gia hạn hoặc nhắc chứng từ',
  'jobDock.sg.delayed': '{n} job đã qua ETD, B/L chưa release',
  'jobDock.sg.delayedSub': 'Mở hàng đợi Delayed',
  'jobDock.sg.standby': '{n} job có BookingNo nhưng còn Standby',
  'jobDock.sg.standbySub': 'Chọn sẵn và mở Xác nhận booking',
  'jobDock.sum': 'Tổng hợp',
  'jobDock.scope': 'theo lọc · {n} job',
  'jobDock.kJobs': 'Số job',
  'jobDock.kCut': 'Cut-off < 48h',
  'jobDock.kOver': 'Việc quá hạn',
  'jobDock.kClose': 'Chờ đóng',
  'jobDock.unit': 'job',
  'jobDock.structure': 'Cơ cấu trạng thái',
  'jobDock.byService': 'Theo dịch vụ',
  'jobDock.byServiceU': 'số job',
  'jobDock.topCus': 'Top khách hàng · số job',
  'jobDock.bySale': 'Theo sales',
  'jobDock.bySaleHint': '· xanh đậm = đang chạy',
  'jobDock.late': 'Quá hạn',
  'jobDock.today': 'Hôm nay',
  'jobDock.soon': 'Sắp tới',
  'jobDock.done': 'Xong: {k}',
  'jobDock.mailHint': 'Thư từ Taskbar · xem cạnh danh sách, Ask HANA tìm job khớp theo số booking / B/L / cont',
  'jobDock.noMail': 'Không còn thư chờ xử lý',
  'jobDock.viewing': 'Thư đang xem',
  'jobDock.matched': 'Job khớp · {by}',
  'jobDock.byKey': 'số booking / B/L {k}',
  'jobDock.byCus': 'khách + POD ({k})',
  'jobDock.byNone': 'không có khoá khớp',
  'jobDock.open': 'Mở',
  'jobDock.noJob': 'Chưa tìm thấy job khớp · tạo job từ thư này',
  'jobDock.newFromMail': 'Tạo job từ thư',
  'jobDock.reply': 'Trả lời thư',
  'jobDock.replyPh': 'Trả lời từ {box}…',
  'jobDock.send': 'Gửi trả lời',
  'jobDock.solve': 'Đánh dấu đã xử lý',
  'jobDock.solved': '✓ Đã xử lý',
  'jobDock.del': 'Xoá',
  'jobDock.matchN': '{n} job khớp · {no}',
  'jobDock.matchNone': 'chưa có job khớp',
  'jobDock.solvedPre': 'Đã xử lý · ',
  'jobDock.readAll': 'Đánh dấu đã đọc tất cả',
  'jobDock.noWrite': 'Chưa mở ghi ở bản này',
});
addMessages('en', {
  'jobDock.label': 'Side panel',
  'jobDock.close': 'Close panel',
  'jobDock.an': 'Analytics',
  'jobDock.task': 'Tasks',
  'jobDock.mail': 'Mail',
  'jobDock.noti': 'Notifications',
  'jobDock.suggest': 'Ask HANA suggests',
  'jobDock.suggestLabel': 'HANA suggestions for the current list',
  'jobDock.sg.rod': '{n} jobs without ROD sent to carrier',
  'jobDock.sg.rodSub': 'Preselect and open bulk ROD',
  'jobDock.sg.cut': '{n} jobs with CY cut-off under 48h',
  'jobDock.sg.cutSub': 'Preselect to extend or chase documents',
  'jobDock.sg.delayed': '{n} jobs past ETD, B/L not released',
  'jobDock.sg.delayedSub': 'Open the Delayed queue',
  'jobDock.sg.standby': '{n} jobs with BookingNo still on Standby',
  'jobDock.sg.standbySub': 'Preselect and open booking confirmation',
  'jobDock.sum': 'Summary',
  'jobDock.scope': 'filtered · {n} jobs',
  'jobDock.kJobs': 'Jobs',
  'jobDock.kCut': 'Cut-off < 48h',
  'jobDock.kOver': 'Overdue tasks',
  'jobDock.kClose': 'Awaiting close',
  'jobDock.unit': 'jobs',
  'jobDock.structure': 'Status mix',
  'jobDock.byService': 'By service',
  'jobDock.byServiceU': 'jobs',
  'jobDock.topCus': 'Top customers · jobs',
  'jobDock.bySale': 'By sales',
  'jobDock.bySaleHint': '· dark blue = running',
  'jobDock.late': 'Overdue',
  'jobDock.today': 'Today',
  'jobDock.soon': 'Upcoming',
  'jobDock.done': 'Done: {k}',
  'jobDock.mailHint': 'Mail from the taskbar · read beside the list; Ask HANA matches jobs by booking / B/L / container',
  'jobDock.noMail': 'No mail waiting',
  'jobDock.viewing': 'Open mail',
  'jobDock.matched': 'Matched jobs · {by}',
  'jobDock.byKey': 'booking / B/L {k}',
  'jobDock.byCus': 'customer + POD ({k})',
  'jobDock.byNone': 'no matching key',
  'jobDock.open': 'Open',
  'jobDock.noJob': 'No matching job · create one from this mail',
  'jobDock.newFromMail': 'Create job from mail',
  'jobDock.reply': 'Reply',
  'jobDock.replyPh': 'Reply from {box}…',
  'jobDock.send': 'Send reply',
  'jobDock.solve': 'Mark as handled',
  'jobDock.solved': '✓ Handled',
  'jobDock.del': 'Delete',
  'jobDock.matchN': '{n} jobs matched · {no}',
  'jobDock.matchNone': 'no matching job',
  'jobDock.solvedPre': 'Handled · ',
  'jobDock.readAll': 'Mark all as read',
  'jobDock.noWrite': 'Writing is not enabled in this build',
});
